import type { DependencyKind } from '@shared/chapterSectionDependencies'

/**
 * The author-facing vocabulary for each dependency kind, in one place so the picker,
 * the chips popover and the conflict warnings all say the same thing.
 *
 * `outgoing`/`incoming` are phrased from the perspective of the section whose row the
 * chip sits on, and are deliberately semantic rather than spatial — "before"/"after"
 * survive an RTL book; "left"/"right" would not.
 */
export interface DependencyKindCopy {
  /** Short name for the kind picker. */
  name: string
  /** One line under the picker explaining what the link asserts. */
  hint: string
  /** Heading above deps where this section is the `from` endpoint. */
  outgoing: string
  /** Heading above deps where this section is the `to` endpoint. */
  incoming: string
  /** Label above the `from` picker in the dialog. */
  fromLabel: string
  /** Label above the `to` picker in the dialog. */
  toLabel: string
}

export const DEPENDENCY_KIND_COPY: Record<DependencyKind, DependencyKindCopy> = {
  order: {
    name: 'חייב לבוא לפני',
    hint: 'אילוץ סדר: המקטע הראשון חייב להיקרא לפני השני.',
    outgoing: 'חייב להגיע לפני:',
    incoming: 'חייב להגיע אחרי:',
    fromLabel: 'לפני',
    toLabel: 'אחרי',
  },
  seed: {
    name: 'מפנה אל / זורע',
    hint: 'חוט תוכן: המקטע הראשון זורע משהו שהשני קוטף — הפניה, הד, זרע צ׳כוב.',
    outgoing: 'זורע ב:',
    incoming: 'נזרע ב:',
    fromLabel: 'זורע',
    toLabel: 'נקטף ב',
  },
}

export const DEPENDENCY_KINDS: DependencyKind[] = ['seed', 'order']
